var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Login Success")]),_c('p',[_vm._v("Status: "+_vm._s(_vm.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }